import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import ButtonLink from '../../common/TrackedButtonLink';

class VideoLeftTextRight extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }


    render() {
        const {titleText, descriptionText, buttonText, buttonTo, videoId, widenVideoUrl} = this.props.data;

        return (
            <div className="product-feature product-feature-reverse-on-mobile-only bg-white py-5" style={{justifyContent: 'center'}}>
                <div className="feature-image feature-image-video">
                    <div className="ratio ratio-16x9">
                        {widenVideoUrl && <iframe
                            src={widenVideoUrl}
                            webkitallowfullscreen mozallowfullscreen allowFullScreen
                            title={titleText}
                            frameBorder="0" allowTransparency="true" scrolling="no" />
                        }
                        {videoId &&
                            <video-js
                                data-account="1213897989"
                                data-player="lgeOB3RfT"
                                data-embed="default"
                                data-video-id={videoId}
                                controls=""
                                data-application-id=""
                                className="vjs-fluid">
                            </video-js>
                        }
                    </div>
                </div>
                <div className="feature-content mb-4">
                    <h2 className="feature-title feature-title--large">{titleText}</h2>
                    <div dangerouslySetInnerHTML={{__html: descriptionText}}/>
                    {buttonText &&
                        <ButtonLink className="btn-primary" to={buttonTo}>{buttonText}</ButtonLink>
                    }
                </div>
            </div>
        );

    }


}

export default branch({
}, VideoLeftTextRight);



// WEBPACK FOOTER //
// ./src/pages/components/page/VideoLeftTextRight.js